import React, { useContext } from 'react';

import { NodeType } from '../dag/dagConstants';
import { InternalDagContextType } from '../dag/InternalDagInterfaces';

type TInternalDagContext = InternalDagContextType & {
  nodeType: NodeType;
  children?: React.ReactNode;
};

export const InternalDagContext = React.createContext<TInternalDagContext>({
  activeDbtCloudProject: null,
  nodeType: 'lens',
  grain: 'project',
});

export const InternalDagProvider = ({
  activeDbtCloudProject,
  grain,
  nodeType,
  toolbarItems,
  children,
}: TInternalDagContext) => {
  return (
    <InternalDagContext.Provider
      value={{
        activeDbtCloudProject,
        grain,
        nodeType,
        toolbarItems,
      }}
    >
      {children}
    </InternalDagContext.Provider>
  );
};

export const useInternalDagContext = () => {
  const context = useContext(InternalDagContext);
  if (context === undefined) {
    throw new Error(
      'useInternalDagContext must be used within a <InternalDagProvider />',
    );
  }

  return context;
};
